import React, { useState } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import { DEFAULT_P2P_ACCESS_MODE, EDIT_PREVIEW_LENGTH, IMAGE_PREVIEW_DIM, IMMEDIATE_P2P_SUBSCRIPTION,
  KEYPRESS_DELAY, MESSAGES_PAGE, MAX_EXTERN_ATTACHMENT_SIZE, MAX_IMAGE_DIM, MAX_INBAND_ATTACHMENT_SIZE,
  READ_DELAY, QUOTED_REPLY_LENGTH, VIDEO_PREVIEW_DIM } from '../config.js';

class MessageAI extends React.Component {
  constructor(props) {
    super(props);

    // Полный список поддерживаемых языков
    this.languages = [
      { code: 'en', name: 'English (English)' },
      { code: 'es', name: 'Spanish (Español)' },
      { code: 'fr', name: 'French (Français)' },
      { code: 'de', name: 'German (Deutsch)' },
      { code: 'it', name: 'Italian (Italiano)' },
      { code: 'ja', name: 'Japanese (日本語)' },
      { code: 'ko', name: 'Korean (한국어)' },
      { code: 'zh-CN', name: 'Chinese Simplified (简体中文)' },
      { code: 'zh-TW', name: 'Chinese Traditional (繁體中文)' },
      { code: 'ar', name: 'Arabic (العربية)' },
      { code: 'ru', name: 'Russian (Русский)' },
      { code: 'nl', name: 'Dutch (Nederlands)' },
      { code: 'pt', name: 'Portuguese (Português)' },
      { code: 'ro', name: 'Romanian (Română)' },
      { code: 'vi', name: 'Vietnamese (Tiếng Việt)' }
    ];
    
    this.getStoredLanguage = this.getStoredLanguage.bind(this);
    this.getBrowserLanguage = this.getBrowserLanguage.bind(this);
    this.onTopUpToken = this.onTopUpToken.bind(this);

    


    this.state = {
      text1: '',
      text2: '',
      text3: '',
      topic: null,
      isLoading: false, // Added loading state
      loadingDots: '', // Added loading dots state
      selectedLanguage: '', //this.props.intl.locale,
      error: '',
      limitError: false,
      mylimitError: false,
    };
  }

  getBrowserLanguage = () => {
    //const language = navigator.language.split(/[-_]/)[0]; // Language without region code
    const language = this.props.intl.locale.split(/[-_]/)[0];
    return language || 'en'; // Фолбэк на английский, если язык не поддерживается
  };

  componentDidMount() {
    this.props.eventToGAnalitycs("message_add_show");
    const selectedLanguage = this.getStoredLanguage() || this.getBrowserLanguage();
    console.info("mess-ai selectedLanguage", selectedLanguage)
    const topicName = this.props.topicName;
    const topic = this.props.tinode.getTopic(topicName);
    this.setState({ selectedLanguage: selectedLanguage, topic: topic });


    const textM = localStorage.getItem(this.props.topicName + "text1");
    const textC = localStorage.getItem(this.props.topicName + "text2");
    if (textM) {
      this.setState({ text1: textM });
    }

    if (textC) {
      this.setState({ text2: textC });
    }
    

  }

  componentWillUnmount() {
    if (this.loadingInterval) {
      clearInterval(this.loadingInterval);
    }
  }

  getStoredLanguage = () => localStorage.getItem(this.props.topicName);

  setStoredLanguage = (language) => localStorage.setItem(this.props.topicName, language);


  handleLanguageChange = (event) => {
    this.setState({ selectedLanguage: event.target.value });
    this.setStoredLanguage(event.target.value);
  }

  handleTextChange = (event) => {
    this.setState({ [event.target.id]: event.target.value, error:'' });
    localStorage.setItem(this.props.topicName + event.target.id, event.target.value);
    //console.info("handleTextChange", this.props.topicName + event.target.id);
  }

  handleRewriteClick = async (mode) => {
    this.props.eventToGAnalitycs("message_add_rewrite");
    this.setState({ isLoading: true, loadingDots: '.' , error: '', text2: '', text3: '', limitError: false, mylimitError: false }); // Start loading

    localStorage.setItem(this.props.topicName + "text2", "");
    // Update loading dots
    const loadingInterval = setInterval(() => {
      this.setState(prevState => ({
        loadingDots: prevState.loadingDots.length < 5 ? prevState.loadingDots + '.' : '.'
      }));
    }, 500);

    //const topicName = this.props.topicName;
   
    const topic = this.state.topic; // this.props.tinode.getTopic(topicName);
  

   //console.info('handleRewriteClick topic.isSubscribed()', topic.isSubscribed());
    if (topic.isSubscribed() ) { 
        this.getFromGPT(topic, mode);
    } else {

      let getQuery = topic.startMetaQuery().withLaterDesc().withLaterSub();
      topic.subscribe(getQuery.build(), undefined)
        .then(ctrl => {
          this.getFromGPT(topic, mode);
        })
        .catch(err => {
          clearInterval(loadingInterval); // Stop updating loading dots
          console.error("Failed subscription", err);
          //this.setState({ text2: "Error occurred. Try again" });
          this.setState({ error: this.props.intl.formatMessage({ id: "error.chat.general" }) + "(1001)", text2: '', isLoading: false }); 

        });
    }

   
    
  }

  getFromGPT = async (topic,mode, loadingInterval) => {
    const query = topic.startMetaQuery().withDesc().build();

    query.desc.inchatgpt = this.state.text1;
    if ( mode && mode === 'suggest' || !this.state.text1 ) {
      query.desc.inchatgpttype = 'GetSuggestion';
      query.desc.inchatgpt = '';
    } 
   
    query.desc.inchatgptlang = this.state.selectedLanguage; 
    //console.info('getFromGPT query:');
    //console.info(query);
    //console.info('topic:', topic);
    
    
    try {
      const result = await topic.getMeta(query);

      //const text = result && result.desc.private !== "" ? result.desc.private : "Error from server. Try again";
      //const text = result && result.desc.outchatgpt !== "" ? result.desc.outchatgpt : "Error from server. Try again";
      const text = result.desc.outchatgpt;
      if (text === "error:token_limit" ) {
        this.setState({ error: this.props.intl.formatMessage({ id: "error.chat.limit" }) + "(1002)" 
          , text2: '' 
          ,  limitError: true , isLoading: false
        }); 
      } else if (text === "error:org_limit" ) {
        this.setState({ error: this.props.intl.formatMessage({ id: "error.chat.limitorg" }) + "(1003)"
          , text2: '' 
          ,  limitError: true , isLoading: false
        }); 
      } else if (text === "error:token_mylimit" ) {
        this.setState({ error: this.props.intl.formatMessage({ id: "error.chat.mylimit" }) 
          , text2: '' 
          ,  mylimitError: true , isLoading: false
        }); 
      } else if (text === "error" ) {
        clearInterval(loadingInterval); // Stop updating loading dots
        console.error('Error:', error);
        //this.setState({ text2: "Error occurred. Try again" });
        this.setState({ error: this.props.intl.formatMessage({ id: "error.chat.general" }) + "(1004)" , text2: '', isLoading: false }); 
      } else {

        const parts = text.split("#f");

      
        const filteredParts = parts.filter(Boolean);

        const textM = filteredParts[0];
        const textC = filteredParts.length > 1 ? filteredParts[1] : "";

        
        this.setState({ text2: textM.trim() });
        this.setState({ text3: textC.trim() });
        localStorage.setItem(this.props.topicName + "text2", textM.trim());
        
        if (result.desc.tokens_used) {
          //this.props.TokensUsed = result.desc.tokens_used;
          this.props.onUpdateTokens (result.desc.tokens_used);
        } 

        //console.log('Success:', result);
      }

    } catch (error) {
      clearInterval(loadingInterval); // Stop updating loading dots
      console.error('Error:', error);
      //this.setState({ text2: "Error occurred. Try again" });
      this.setState({ error: this.props.intl.formatMessage({ id: "error.chat.general" }) + "(1005)", text2: '', isLoading: false }); 
    } finally {
      clearInterval(loadingInterval); // Stop updating loading dots
      this.setState({ isLoading: false, loadingDots: '' }); // Reset loading state
    }
  }

  handleSendMessage = () => {
    if (this.state.text2) {
      this.props.eventToGAnalitycs("message_add_send");
      this.props.onSendMessage(this.state.text2);
      this.setState({ message: '' });
      this.props.onClose();
    }
  }

  rewriteText = (text) => {
    
    return new Promise((resolve) => {
      setTimeout(() => resolve(`Rewritten version of: ${text}`), 1000);
    });
  };

  onTopUpToken = () => {
    //console.info('onTopUpToken');
    this.props.onClose(); // Закрыть текущее окно
    this.props.onAddTokens(); 
  }

  render() {
    return (
      
      <div className="message-ai-overlay">
        <div className="message-ai-container">
          <div className="linecontainer" >
            {this.state.topic && this.state.topic.private &&
              <div className="messaiaddtoken"  >
               
               <span key={this.props.TokensUsed}> <FormattedMessage id="tokens" defaultMessage="Tokens:" description="Tokens:"/> {' '}  { this.props.TokensUsed} {'/'}   {this.props.Tokens} </span>

            
              <button id='linkTopUp' className='link'  style={{ marginLeft: '5px' }}
                    
                    onClick={this.onTopUpToken}
                  >
                     <FormattedMessage id="topup" defaultMessage="Top up" description="Top up"/>
                  {/*this.props.intl.formatMessage({ id: "topup" })*/}
              </button>
                
              </div>
            }


            <div className="language-selector">
              {/*<label  className="small" >🌎</label>*/}
              <select
                value={this.state.selectedLanguage}
                onChange={this.handleLanguageChange}
                style={{ marginLeft: '10px' }}
              >
                {this.languages.map(lang => (
                  <option key={lang.code} value={lang.code}>{lang.name}</option>
                ))}
              </select>
            </div>
          </div>

          <h2>
          <FormattedMessage id="addmessage" defaultMessage="Add message"
                description="Label for editing 'Add message'" />
          </h2>

           <div><label className="small">
            <FormattedMessage id="label_orig_message" defaultMessage="Your message"
                description="Label for editing 'Your message'" />
            </label>
            </div>

          <textarea
            id="text1"
            rows="7"
            maxLength="3000"
            value={this.state.text1}
            onChange={this.handleTextChange}
            placeholder=  {this.props.intl.formatMessage({ id: "type_your_message" })} 
          />
          <button className="outline" onClick={this.handleRewriteClick} >
            

            <FormattedMessage id="rewrite_by_ai" defaultMessage="Rewrite by AI"
                        description="Rewrite by AI" />

          </button>

          <button className="outline" onClick={() => this.handleRewriteClick("suggest")} >
            

            <FormattedMessage id="suggest_by_ai" defaultMessage="AI proposal"
                        description="AI proposal" />

          </button>

          

          {this.state.error && (
            <div className="error-message">
              {this.state.error}
              {this.state.limitError && false && (
                <button  className='link'
                  
                  onClick={() => {
                    
                    this.props.onClose(); // Закрыть текущее окно
                    this.props.onNewTalkView(this.props.topicName); // Вызов функции с TopicName
                  }}
                >
                 {this.props.intl.formatMessage({ id: "error.chat.limit.link" })}
                </button>
              )}
               {this.state.mylimitError  &&  this.state.topic.private && (
                <button  className='link'
                  onClick={() => {
                    
                    this.props.onClose(); // Закрыть текущее окно
                    this.props.onAddTokens(); 
                  }}
                >
                 {' ' + this.props.intl.formatMessage({ id: "error.chat.mylimit.link" })}
                </button>
              )}

              {this.state.mylimitError  &&  !this.state.topic.private && (
                <>
                 {' ' + this.props.intl.formatMessage({ id: "error.chat.mylimit.linkowner" })}
                 </>
              )}

            </div>
          )}

          { /*!this.state.error &&*/ (
            <>


           <div style={{ marginTop: '20px' }}> <label className="small">
            <FormattedMessage id="label_rewrited_message" defaultMessage="Rewrited message"
                description="Label for editing 'Rewrited message'" />
            </label>
            </div>
          <textarea
            id="text2"
            rows="7"
            value={this.state.isLoading ? this.state.loadingDots : this.state.text2}
            onChange={this.handleTextChange}
            placeholder= {this.props.intl.formatMessage({ id: "rewritten_message" })}
            readOnly={this.state.isLoading} // Make it read-only when loading
            maxLength="3000"
          /> 
          </>) }
         {
            this.state.text3 && ( <>
                <div style={{ marginTop: '10px' }}> <label className="small">
                    <FormattedMessage id="label_rewrited_clarifacation" defaultMessage="Clarification"
                        description="Label for  'Clarification'" />
                    </label>
                    </div>
                <textarea
                    id="text3"
                    rows="7"
                    value={this.state.text3}
                    placeholder= {this.props.intl.formatMessage({ id: "clarification_message" })} 
                    readOnly = {true} // Make it read-only when loading
                /> 
                </>)
        }
         <div className="dialog-buttons">
            {!this.state.error && (
              <button className="primary" onClick={this.handleSendMessage} disabled={this.state.isLoading || this.state.error}>
                

                <FormattedMessage id="send_message" defaultMessage="Send message"
                        description="Send message" />

              </button>
            )}
            <button className="secondary" onClick={() => {
                  this.setState({ message: '' });
                  localStorage.setItem(this.props.topicName + "text1", "");
                  localStorage.setItem(this.props.topicName + "text2", "");
                  this.props.onClose();
            }}>
              
              <FormattedMessage id="action_cancel" defaultMessage="Cancel"
                        description="Cancel" />
            </button>
         </div>
        </div>
      </div>
    );
  }
}

export default MessageAI;
